var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrigger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 9.5L2.03333 10.2L4.83333 7.4L7.63333 10.2L8.33333 9.5L4.83333 6L1.33333 9.5ZM14.6333 5.8L11.8333 8.6L9.03333 5.8L8.33333 6.5L11.8333 10L15.3333 6.5L14.6333 5.8ZM4.83333 11C4.28103 11 3.83333 11.4477 3.83333 12C3.83333 12.5523 4.28103 13 4.83333 13C5.38563 13 5.83333 12.5523 5.83333 12C5.83333 11.4477 5.38563 11 4.83333 11ZM11.8333 5C12.3856 5 12.8333 4.5523 12.8333 4C12.8333 3.4477 12.3856 3 11.8333 3C11.281 3 10.8333 3.4477 10.8333 4C10.8333 4.5523 11.281 5 11.8333 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrigger);
export default __webpack_public_path__ + "static/media/ic-trigger.e44c8c8980dff7c3ff5c63319f9cc35f.svg";
export { ForwardRef as ReactComponent };